/**
 * Generate a URL-safe slug from a name.
 *
 * @param name - The name to convert to a slug
 * @returns A lowercase, hyphen-separated slug (max 100 chars)
 *
 * @example
 * generateSlug("Acme Corp") // "acme-corp"
 * generateSlug("Über Technologies") // "uber-technologies"
 * generateSlug("My Company™") // "my-company"
 */
export function generateSlug(name: string): string {
  return (
    name
      .toLowerCase()
      // Normalize unicode and remove diacritics (ü → u, ñ → n)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      // Remove special characters except spaces and hyphens
      .replace(/[^a-z0-9\s-]/g, '')
      // Trim whitespace
      .trim()
      // Replace spaces with hyphens
      .replace(/\s+/g, '-')
      // Collapse multiple hyphens
      .replace(/-+/g, '-')
      // Remove leading/trailing hyphens
      .replace(/^-|-$/g, '')
      // Limit to 100 characters
      .slice(0, 100)
  );
}
